export const orange = {
    50: '#FFF5E8',
    100: '#FFECD2',
    150: '#FFD9A4',
    200: '#FFC577',
    300: '#FFB049',
    400: '#FF9514',
    500: '#E67700',
    600: '#B85C00',
    700: '#97520C',
    800: '#6D4009',
    850: '#4D3008',
    900: '#332006',
    950: '#1A1003'
};

//# sourceMappingURL=orange.js.map